import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

import TrainingScheduleModal from "./TrainingScheduleModal";
import { Toolbar } from "@mui/material";
import TrainingDetailsModal from "./TrainingDetailsModal";
import TrainingCompletionModal from "./TrainingCompletionModal";

import {
  getAllTrainingName,
  getAllTrainingScheduleList,
  getEmployeeTrainingSchedule,
  getTrainingScheduleDetailsInfo,
  getTrainingScheduleInfo,
} from "../../services/TrainingServices";
import { errorAlert } from "../../../common/components/Toasts/CustomToasts";
import {
  EditIcon,
  Information,
  RescheduleIcon,
  RightIcon,
} from "../../../assets/CommonAssets";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonTransactionPaginationTable from "../../../common/components/CommonTable/CommonTransactionPaginationTable";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import CommonHeading from "../../../common/components/Custom Hooks/CommonHeading";

const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
  {
    id: 4,
    permission: "View",
    isAction: true,
  },
  {
    id: 5,
    permission: "Shedule",
    isAction: true,
  },
];

const TrainingScheduleMaster = () => {
  const { control, setValue, watch } = useForm();
  const watchFromDate = watch("fromDate")?.toISOString()?.split("T")[0];
  const watchTodate = watch("toDate")?.toISOString()?.split("T")[0];
  const [TrainingDetailsModalOpen, setTrainingDetailsModalOpen] =
    useState(false);
  const [trainingScheduleModalOpen, setTrainingScheduleModalOpen] =
    useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowPatchData, setSelectedRowPatchData] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [trainingScheduleList, setTrainingScheduleList] = useState([]);
  const [TrainingCompletionModalOpen, setTrainingCompletionModalOpen] =
    useState(false);
  const [trainingScheduleNameOptions, setTrainingScheduleNameOptions] =
    useState([]);
  const [trainingCompletionEmpList, setTrainingCompletionEmpList] = useState(
    [],
  );
  const [trainingNameOptions, setTrainingNameOptions] = useState([]);
  const [scheduleDetailsInfo, setScheduleDetailsInfo] = useState(null);
  const [count, setCount] = useState(0);
  const [listingObject, setListingObject] = useState({
    searchString: "",
    page: page,
    size: rowsPerPage,
    searchId: null,
    menuId: null,
    fromDate: watchFromDate,
    toDate: watchTodate,
  });

  const populateTable = (forPagination) => {
    let tempObj = { ...listingObject, page: !forPagination ? 0 : page };

    if (page === 0) {
      showSpinner(true);
    }
    getAllTrainingScheduleList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200 || res.statusCode === 204) {
          if (forPagination) {
            setTrainingScheduleList((prevData) => [...prevData, ...res.result]);
          } else {
            setTrainingScheduleList(res.result);
            // setPage(0);
          }
          setCount(res.count);
          showSpinner(false);
        }
      })
      .catch((error) => {
        console.log(error);
        showSpinner(false);
      });
  };

  //   const handleDelete = () => {
  //     setOpenBackdrop(true);
  //     if (selectedRow !== null) {
  //       deleteAllTrainingSchedule(selectedRow.Id)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           successAlert(res.message);
  //           // setPage(0);
  //           populateTable();
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setSelectedRow(null);
  //         })
  //         .catch((errors) => {
  //           console.log("err", errors);
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setTrainingScheduleModalOpen(false);
  //           setSelectedRow(null);
  //           errorAlert(errors.message);
  //         });
  //     }
  //   };
  useEffect(() => {
    populateTable();
  }, [
    listingObject?.searchId,
    listingObject?.searchString,
    listingObject?.fromDate,
    listingObject?.toDate,
  ]);

  /****************** renderActions *****************/
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-[2px] items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <div className="flex gap-2 cursor-pointer items-center">
                {actions.permission === "Edit" ? (
                  <button
                    type="button"
                    onClick={
                      () => (
                        setSelectedRow({ ...row, edit: true, action: "edit" }),
                        setTrainingScheduleModalOpen(true)
                      )
                      // setSelectedRow(row)
                    }
                  >
                    <EditIcon
                      title={"Edit"}
                      type={"button"}
                      sx={{ color: "gray" }}
                    />
                  </button>
                ) : null}
              </div>
            ) : null}
            {actions.isAction === true ? (
              <div className="flex gap-2 cursor-pointer">
                {actions.permission === "View" ? (
                  // row?.Status === "Completed" ?
                  <div onClick={() => setTrainingDetailsModalOpen(true)}>
                    <Information
                      title={"Information"}
                      sx={{ color: "#D11A2A" }}
                      type={"button"}
                      onClick={() => {
                        setSelectedRow({
                          ...row,
                          edit: false,
                          action: "information",
                        });
                      }}
                    />
                  </div>
                ) : null}
              </div>
            ) : null}{" "}
            {actions.permission === "Edit" ? (
              <div
                onClick={() => (
                  setTrainingScheduleModalOpen(true),
                  setSelectedRow({ ...row, edit: false, action: "reschedule" })
                )}
              >
                <RescheduleIcon
                  title={"Reschedule Training"}
                  type={"button"}
                  sx={{ color: "gray" }}
                />
              </div>
            ) : null}
            {actions.permission === "Edit" &&
            row?.["Training Type"] === "Trainer" &&
            row?.["Is Completed"] === false ? (
              <div
                className="flex items-center"
                onClick={() => {
                  setTrainingCompletionModalOpen(true);
                  setSelectedRow({ ...row, edit: false, action: "completion" });
                }}
              >
                <RightIcon
                  title={"Training Completion"}
                  type={"button"}
                  sx={{ color: "gray" }}
                />
              </div>
            ) : null}
          </>
        ))}
      </div>
    );
  };

  /****************** renderInput ********************/
  // const renderInput = (row, index, header) => {
  //   return (
  //     <>
  //       {header === "Status" && (
  //         <button
  //           className={`h-6 rounded-lg w-32 whitespace-nowrap border  capitalize px-5 text-center
  //                    ${
  //                      row?.Status === "Completed"
  //                        ? "text-customGreen border-customGreen"
  //                        : "text-customRed border-customRed"
  //                    }`}
  //           type="button"
  //         >
  //           {row?.Status}
  //         </button>
  //       )}
  //     </>
  //   );
  // };
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <span
            className={`inline-flex items-center  px-3 py-1 rounded-full text-xs font-semibold capitalize
            ${
              row?.Status &&
              (row?.Status === "Completed"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-orange-500")
            }`}
          >
            <span
            // className={`w-1.5 h-1.5 rounded-full ${
            //   row?.Status === "Completed" ? "bg-green-500" : "bg-orange-500"
            // }`}
            />
            {row?.Status ?? "-"}
          </span>
        )}
        {header === "Trainer Name" && (
          <span className="text-sm text-gray-600">
            {row?.["Trainer Name"] ? row?.["Trainer Name"] : "-"}
          </span>
        )}
        {header === "Mode" && (
          <span className="text-sm text-gray-600">
            {row?.Mode ? row?.Mode : "-"}
          </span>
        )}
      </>
    );
  };
  useEffect(() => {
    if (!selectedRow) return;

    if (
      selectedRow?.action === "completion" &&
      selectedRow?.["Training Id"] &&
      selectedRow?.["Training Schedule Id"]
    ) {
      setOpenBackdrop(true);

      getEmployeeTrainingSchedule(
        selectedRow["Training Id"],
        selectedRow["Training Schedule Id"],
      )
        .then((res) => res.data)
        .then((res) => {
          if (res.statusCode === 200) {
            setTrainingCompletionEmpList(res.result);
          }
        })
        .catch((err) => errorAlert(err.message))
        .finally(() => setOpenBackdrop(false));
    } else if (
      (selectedRow?.action === "edit" ||
        selectedRow?.action === "reschedule") &&
      selectedRow?.["Training Schedule Id"]
    ) {
      setOpenBackdrop(true);
      getTrainingScheduleInfo(selectedRow?.["Training Schedule Id"])
        .then((res) => res.data)
        .then((res) => {
          if (res.statusCode === 200) {
            let finalData = JSON.parse(res?.result);
            setSelectedRowPatchData(finalData);
          }
        })
        .catch((err) => errorAlert(err.message))
        .finally(() => setOpenBackdrop(false));
    } else if (
      (selectedRow?.action === "edit" ||
        selectedRow?.action === "information") &&
      selectedRow?.["Training Schedule Id"]
    ) {
      setOpenBackdrop(true);
      getTrainingScheduleDetailsInfo(selectedRow?.["Training Schedule Id"])
        .then((res) => res.data)
        .then((res) => {
          if (res.statusCode === 200) {
            let finalData = JSON.parse(res?.result);
            setScheduleDetailsInfo(finalData);
            console.log(scheduleDetailsInfo, "scheduleDetailsInfo");
          }
        })
        .catch((err) => errorAlert(err.message))
        .finally(() => setOpenBackdrop(false));
    }
  }, [selectedRow]);

  return (
    <div className="px-2 my-1">
      {CommonHeading("Training Schedule")}
      <div className="flex gap-2 w-full items-center mt-2">
        <div className="flex w-full lg:grid grid-cols-1 gap-2 items-center ">
          <div className="grid w-full gap-2 grid-cols-2">
            <SearchDropdown
              isDisabled={
                selectedRow?.editType == "View" ||
                selectedRow?.editType == "Schedule"
              }
              control={control}
              name="training"
              placeholder="Search by Training*"
              isSearchable={true}
              dataArray={trainingNameOptions}
              searchIcon={true}
              handleInputChange={(e) => {
                const tempCheckChar =
                  e !== null ? UseCheckConsecutiveCharacters(e) : true;
                if (e !== "" && tempCheckChar) {
                  getAllTrainingName(e)
                    .then((response) => {
                      setTrainingNameOptions(response.data.result);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                } else {
                  setTrainingNameOptions([]);
                }
              }}
              onChange={(e) => {
                if (e !== "") {
                  setSearchString(e);
                } else {
                  setSearchString(null);
                }
              }}
              isClearable={true}
              // error={errors?.training}
            />
            <div className="flex gap-2">
              <DatePickerField
                name="fromDate"
                label="From Date"
                control={control}
                inputFormat={"dd-MM-yyyy"}
                // error={errors.blockDate}
                slotProps={{ textField: { size: "small" } }}
              />
              <DatePickerField
                name="toDate"
                label="To Date"
                control={control}
                inputFormat={"dd-MM-yyyy"}
                // error={errors.blockDate}
                slotProps={{ textField: { size: "small" } }}
              />
              <div>
                <CommonButton
                  className="bg-customBlue text-white"
                  searchIcon={true}
                  onClick={() =>
                    setListingObject({
                      searchString: watch("training")?.label,
                      page: page,
                      size: rowsPerPage,
                      searchId: watch("training")
                        ? watch("training")?.id
                        : null,
                      menuId: null,
                      fromDate: watchFromDate,
                      toDate: watchTodate,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="grid justify-end xl:col-span-3 w-1/3">
          {userActions &&
            userActions.map((obj) => (
              <>
                {!obj.isAction && obj.permission === "Create" ? (
                  <CommonButton
                    onClick={() => setTrainingScheduleModalOpen(true)}
                    label="+ New"
                    className="modalButton bg-customBlue text-white"
                  />
                ) : null}
              </>
            ))}
        </div>
      </div>
      {spinner ? (
        <div className="grid justify-center items-center pt-12">
          <LoadingSpinner />
        </div>
      ) : null}

      {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
      {trainingScheduleModalOpen && (
        <TrainingScheduleModal
          setTrainingScheduleList={setTrainingScheduleList}
          setTrainingScheduleModalOpen={setTrainingScheduleModalOpen}
          trainingScheduleModalOpen={trainingScheduleModalOpen}
          // setTrainingScheduleTableData={setTrainingScheduleTableData}
          // trainingScheduleTableData={trainingScheduleTableData}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          setOpenBackdrop={setOpenBackdrop}
          openBackDrop={openBackDrop}
          populateTable={populateTable}
          selectedRowPatchData={selectedRowPatchData}
          setSelectedRowPatchData={setSelectedRowPatchData}
        />
      )}
      {TrainingDetailsModalOpen && scheduleDetailsInfo && (
        <TrainingDetailsModal
          setScheduleDetailsInfo={setScheduleDetailsInfo}
          scheduleDetailsInfo={scheduleDetailsInfo}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          TrainingDetailsModalOpen={TrainingDetailsModalOpen}
          setTrainingDetailsModalOpen={setTrainingDetailsModalOpen}
        />
      )}
      {TrainingCompletionModalOpen && (
        <TrainingCompletionModal
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          TrainingCompletionModalOpen={TrainingCompletionModalOpen}
          setTrainingCompletionModalOpen={setTrainingCompletionModalOpen}
          setTrainingCompletionEmpList={setTrainingCompletionEmpList}
          trainingCompletionEmpList={trainingCompletionEmpList}
          populateTable={populateTable}
        />
      )}
      <div className={!spinner ? "block" : "hidden"}>
        {trainingScheduleList.length > 0 ? (
          <CommonTransactionPaginationTable
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            populateTable={() => populateTable()}
            count={trainingScheduleList.length}
            highlightRow={false}
            dataResult={trainingScheduleList}
            renderActions={renderActions}
            renderInput={renderInput}
            editableColumns={["Status", "assignedDate", "Trainer Name", "Mode"]}
            removeHeaders={[
              "Training Id",
              "Location Id",
              "Trainer Id",
              "Training Schedule Id",
              "Location Name",
              "Is Completed",
            ]}
          />
        ) : (
          <>
            {!spinner && (
              <div className="flex justify-center">
                <h3 className="flex justify-center mt-20 font-bold text-gray-600">
                  No Records Found...
                </h3>
              </div>
            )}
          </>
        )}
      </div>
      <ConfirmationModal
        confirmationOpen={openDeleteModal}
        confirmationHandleClose={() => {
          setOpenDeleteModal(false);
          setSelectedRow(null);
        }}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to delete this record?"
        // confirmationSubmitFunc={handleDelete}
        confirmationButtonMsg="Delete"
      />
    </div>
  );
};

export default TrainingScheduleMaster;
